import { TabsContent } from "@/components/ui/tabs";
import { EmptyState, StatusBadge } from "@/components/bits";

export function AttendanceTab({ attendance }) {
  return (
    <TabsContent value="attendance">
      {attendance.length === 0 ? (
        <EmptyState title="No attendance records yet" description="Employees check in from their workspace." testId="attendance-empty" />
      ) : (
        <div className="bg-white border border-border/60 rounded-xl overflow-x-auto">
          <table className="w-full text-sm" data-testid="attendance-table">
            <thead className="bg-[#F8FAFC] border-b border-border/60 text-left text-xs text-muted-foreground">
              <tr>
                <th className="px-5 py-3.5 font-semibold">Employee</th>
                <th className="px-5 py-3.5 font-semibold">Date</th>
                <th className="px-5 py-3.5 font-semibold">Check-in</th>
                <th className="px-5 py-3.5 font-semibold">Check-out</th>
                <th className="px-5 py-3.5 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody>
              {attendance.map((a) => (
                <tr key={a.id} className="border-b border-border/40">
                  <td className="px-5 py-4 font-semibold">{a.employee_name}<span className="text-xs text-muted-foreground ml-2">{a.emp_code}</span></td>
                  <td className="px-5 py-4 text-xs">{a.date}</td>
                  <td className="px-5 py-4 text-xs">{a.check_in ? new Date(a.check_in).toLocaleTimeString("en-IN") : "—"}</td>
                  <td className="px-5 py-4 text-xs">{a.check_out ? new Date(a.check_out).toLocaleTimeString("en-IN") : "—"}</td>
                  <td className="px-5 py-4"><StatusBadge status={a.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </TabsContent>
  );
}
